import React from 'react'
import { TeamGQL } from '../../../../Api'
import { InfoStyle, SideCon, StatHeaderStyle, TeamImg } from './styles'
import { EventGQL } from '../../../../Api'
import { getTeamImage, getTeamRecord } from '../../../../Utils'

type TeamStatsProps = {
  homeTeam: TeamGQL | null
  awayTeam: TeamGQL | null
  eventInfo: EventGQL | null
}

export const Header: React.FC<React.PropsWithChildren<TeamStatsProps>> = ({
  homeTeam,
  awayTeam,
  eventInfo,
}) => {
  return (
    <>
      {homeTeam && awayTeam && (
        <StatHeaderStyle>
          <SideCon side="left">
            <TeamImg
              src={getTeamImage(
                awayTeam.fullName,
                eventInfo?.seasonSegment,
                eventInfo?.year
              )}
              alt=""
            />
            <InfoStyle side="left">
              <h2>{awayTeam.fullName}</h2>
              <p>{getTeamRecord(awayTeam, eventInfo?.seasonSegment)}</p>
            </InfoStyle>
          </SideCon>
          <SideCon side="right">
            <InfoStyle side="right">
              <h2>{homeTeam.fullName}</h2>
              <p>{getTeamRecord(homeTeam, eventInfo?.seasonSegment)}</p>
            </InfoStyle>
            <TeamImg
              src={getTeamImage(
                homeTeam.fullName,
                eventInfo?.seasonSegment,
                eventInfo?.year
              )}
              alt=""
            />
          </SideCon>
        </StatHeaderStyle>
      )}
    </>
  )
}
